var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#158A73"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#158A73"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4494_15950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2153 9.99988L11.4803 7.57988C11.3353 7.10488 10.6653 7.10488 10.5253 7.57988L9.78535 9.99988H7.56035C7.07535 9.99988 6.87535 10.6249 7.27035 10.9049L9.09035 12.2049L8.37535 14.5099C8.23035 14.9749 8.77035 15.3499 9.15535 15.0549L11.0003 13.6549L12.8453 15.0599C13.2303 15.3549 13.7703 14.9799 13.6253 14.5149L12.9103 12.2099L14.7303 10.9099C15.1253 10.6249 14.9253 10.0049 14.4403 10.0049H12.2153V9.99988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4494_15950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLevel);
export default __webpack_public_path__ + "static/media/CurrentLevel.fd2ee9d0d9dcb49d127e8653a60efaed.svg";
export { ForwardRef as ReactComponent };